// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import cx from 'classnames';
import { Record } from '@fulcrumapp/fulcrum-core';
import { cssInJS } from '../../utils/styles';

export default class RecordLinkPickerItem extends React.Component {
  static propTypes = {
    record: PropTypes.instanceOf(Record).isRequired,
    onClick: PropTypes.func.isRequired,
  };

  render() {
    const { styles } = RecordLinkPickerItem;

    return (
      <div
        className={css(styles.container)}
        style={{ height: 32 }}
        onClick={this.handleClick}
      >
        {this.props.record.displayValue}
      </div>
    );
  }

  handleClick = (event) => {
    this.props.onClick(this.props.record);
  };
}

const styles = cssInJS({
  container: {
    paddingTop: 6,
    paddingLeft: 6,
    cursor: 'pointer',
    borderBottom: '1px solid #f1f1f1',
    color: THEME.linkColor,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    ':hover': {
      backgroundColor: '#f1f1f1',
      color: THEME.linkColorHighlight,
    },
  },
});

RecordLinkPickerItem.styles = styles;
